import { AppStore } from "../../rootReducer";

export const getAccountUser = (state: AppStore) => {
  return state.accountStore.accountUser;
};

export const getIsLoadingAccountUser = (state: AppStore) => {
  return state.accountStore.isLoading;
};
